import React from 'react';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { MdOutlineCheckBoxOutlineBlank } from 'react-icons/md';
import Select from 'react-select';

import { ErrorMessage, useField } from 'formik';

import * as style from './TextFields.module.css';

export const TextField = ({ ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={style.inputContainer}>
      <input
        className={meta.touched && meta.error ? style.invalid : style.formInput}
        {...field}
        {...props}
      />
      <div className={style.errorMessageContainer}>
        <ErrorMessage
          component="div"
          name={field.name}
          className={style.errorMessage}
        />
      </div>
    </div>
  );
};

export const TextArea = ({ ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={style.inputContainer}>
      <textarea
        className={meta.touched && meta.error ? style.invalid : style.formInput}
        {...field}
        {...props}
      />
      <div className={style.errorMessageContainer}>
        <ErrorMessage
          component="div"
          name={field.name}
          className={style.errorMessage}
        />
      </div>
    </div>
  );
};

export const SelectBox = ({ ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={style.inputContainer}>
      <select
        className={meta.touched && meta.error ? style.invalid : style.formInput}
        {...field}
        {...props}
      />
      <div className={style.errorMessageContainer}>
        <ErrorMessage
          component="div"
          name={field.name}
          className={style.errorMessage}
        />
      </div>
    </div>
  );
};

export const Checkbox = ({ ...props }) => {
  const [field] = useField(props);
  return (
    <div className={style.Checkbox}>
      <label>
        <input {...field} {...props} />
        {!props.checked ? (
          <MdOutlineCheckBoxOutlineBlank
            className={style.SPuncheckedIcon}
            color={props.colour}
            size={props.boxsize}
          />
        ) : (
          <IoMdCheckboxOutline
            className={style.checkedIcon}
            color={props.checkedColor}
          />
        )}
        <span
          className={`p2 ${style.labelTextBox}`}
          style={{ color: `${props.colour}`, fontSize: `${props.size}` }}
        >
          <div
            className={props.checked ? style.labelText : ''}
            style={{
              color: props.checked
                ? `${props.checkedColor}`
                : `${props.colour}`,
            }}
          >
            {props.label}
          </div>
          <div
            className={
              props.checked ? style.checkedLabelCount : style.labelCount
            }
          >
            {props.count}
          </div>
        </span>
      </label>
    </div>
  );
};

export const SPCheckbox = ({ ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={style.Checkbox}>
      <label>
        <input
          {...field}
          {...props}
          className={
            meta.touched && meta.error ? style.invalid : style.formInput
          }
        />
        {!props.checked ? (
          <MdOutlineCheckBoxOutlineBlank
            className={style.SPuncheckedIcon}
            color={props.colour}
          />
        ) : (
          <IoMdCheckboxOutline
            className={style.SPcheckedIcon}
            color={props.checkedColor}
          />
        )}
        <span
          className={`p2 ${style.labelTextBox}`}
          style={{ color: `${props.colour}`, fontSize: 12, lineHeight: '18px' }}
        >
          <div
            className={props.checked ? style.SPlabelText : ''}
            style={{
              color: props.checked
                ? `${props.checkedColor}`
                : `${props.colour}`,
            }}
          >
            {props.label}
          </div>
          <div
            className={
              props.checked ? style.checkedLabelCount : style.labelCount
            }
          >
            {props.count}
          </div>
        </span>
      </label>
      {meta.touched && !props.checked && (
        <div className={style.sperrorMessageContainer}>
          <ErrorMessage
            component="div"
            name={field.name}
            className="captionEmphasis"
            style={{ color: '#D1384A', paddingLeft: 20 }}
          />
        </div>
      )}
    </div>
  );
};

export const CountrySelectBox = ({ ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={style.inputContainer}>
      <Select
        className={meta.touched && meta.error ? style.invalid : style.formInput}
        {...field}
        {...props}
      />
      <div className={style.errorMessageContainer}>
        <ErrorMessage
          component="div"
          name={field.name}
          className={style.errorMessage}
        />
      </div>
    </div>
  );
};
